import { FC, RefObject } from 'react'
import { SituacaoDiagnosticoType } from '../../../../../../_metronic/helpers'
import { InfoAlert } from '../../../../../components/Info/InfoAlert'
import { AtendimentoView } from '../../../atendimento/core/_models'
import { DiagnosticoForm } from '../../atendimento-video/modal/DiagnosticoForm'

type Props = {
  atendimento: AtendimentoView
  onAtualizar: () => void
  onSituacaoChange: (situacao: SituacaoDiagnosticoType | undefined) => void
  /** O que falta para finalizar (`pendenciaDiagnostico`); `null` quando pronto. */
  pendencia: string | null
  /** Já tentou finalizar com o diagnóstico pendente: destaca a seção e mostra o que falta. */
  mostrarErro: boolean
  /** Título focável, para o rodapé e o "Finalizar e assinar" levarem até a seção. */
  tituloRef: RefObject<HTMLHeadingElement>
}

/** Última seção do parecer: situação diagnóstica e CIDs, gravados na hora. */
export const DiagnosticoParecer: FC<Props> = ({
  atendimento,
  onAtualizar,
  onSituacaoChange,
  pendencia,
  mostrarErro,
  tituloRef,
}) => {
  const erro = mostrarErro && pendencia
  return (
    <section
      aria-labelledby='parecer-diagnostico-titulo'
      className={`card card-bordered ${erro ? 'border-danger' : ''}`}
    >
      <div className='card-body p-6'>
        <h2
          id='parecer-diagnostico-titulo'
          ref={tituloRef}
          tabIndex={-1}
          className='fs-5 fw-bold mb-1'
        >
          Diagnóstico do parecer
        </h2>
        <p className='text-muted fs-7 mb-5'>
          Obrigatório para finalizar: a situação diagnóstica ou ao menos um CID.
        </p>
        {erro && (
          <InfoAlert variant='danger' role='alert' className='mb-5'>
            O parecer foi salvo. Para finalizar: {pendencia}
          </InfoAlert>
        )}
        <DiagnosticoForm
          atendimento={atendimento}
          onAtualizar={onAtualizar}
          onSituacaoChange={onSituacaoChange}
        />
      </div>
    </section>
  )
}
